<div
  *ngIf="isVisible"
  class="relative z-50"
  aria-labelledby="confirm-modal-title"
  role="dialog"
  aria-modal="true"
>
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity" (click)="onCancel()"></div>

  <!-- Modal container -->
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto" (click)="onCancel()">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        class="px-6 pt-6 pb-6 relative transform overflow-hidden rounded-2xl bg-white dark:bg-secondary-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md"
        (click)="$event.stopPropagation()"
      >
        <!-- Close button -->
        <div class="absolute right-0 top-0 pr-4 pt-4">
          <button
            type="button"
            (click)="onCancel()"
            [disabled]="processing"
            class="rounded-md bg-transparent text-gray-400 hover:text-gray-500 focus:outline-none disabled:opacity-50"
          >
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Modal content -->
        <div class="text-center">
          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full mb-4" [ngClass]="iconClasses">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
            </svg>
          </div>

          <h3 id="confirm-modal-title" class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            {{ title }}
          </h3>

          <p *ngIf="message" class="text-sm text-gray-500 dark:text-primary-200 mb-6">
            {{ message }}
          </p>

          <div class="flex gap-3" [class.mt-2]="!message">
            <button
              type="button"
              (click)="onCancel()"
              [disabled]="processing"
              class="flex-1 rounded-lg border border-gray-300 dark:border-[#3b4377] bg-white dark:bg-transparent px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-primary-200 hover:bg-gray-50 dark:hover:bg-secondary-900 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {{ cancelLabel }}
            </button>
            <button
              type="button"
              (click)="onConfirm()"
              [disabled]="processing"
              class="flex-1 inline-flex items-center justify-center rounded-lg px-4 py-2.5 text-sm font-medium text-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
              [ngClass]="confirmButtonClasses"
            >
              <svg *ngIf="processing" class="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
